import React, { Component } from 'react';
import { connect } from 'react-redux';
import {setPrice,setAmount,setOrderType} from '../../../../actions/ui/marketplace';
import {matchOrders} from '../../../../actions/orderbook/matchingEngine';
import ReactTooltip from 'react-tooltip'
import {lowestDenom} from '../../../../config';
import $ from 'jquery';

class OrderItem extends Component {
  constructor(){
    super();
    this.state = {open:false};
  }
  render() {
    let {amount,price,type,id,cml,isBlank,orders} = this.props
    let color = this.props.type === 'buy' ? "#60ca60" : '#de7272';
    let cursor = this.props.cancel ? '' : 'pointer';
    if(!isBlank){
      return (
        <>
        <tr
          data-for={"showOrder"} data-tip={"hello world"} style={{cursor}}
          onClick={this.handleFormSubmit.bind(this,{id,price,type,amount})}
          ref={(c) => { this.ref = c; }}
          data-tip={`hello`} data-for={id}
          onMouseOver={() => { ReactTooltip.show(this.ref); }}
          onMouseLeave={() => { ReactTooltip.hide(this.ref); }}
        >
          <td style={{color}}>{price.toString().substring(0,9)}</td>
          <td>{amount.toString().substring(0,9)}</td>
          <td><span>{`${price*amount}`.substring(0,9)}</span></td>
          <td><span>{cml.toString().substring(0,10)}</span></td>
        </tr>
        <ReactTooltip id={id} place="right" type="dark" effect="solid" className='extraClass' delayHide={100}>
          {this.renderTable(orders)}
        </ReactTooltip>
        </>
      );
    }
    else {
      return (
        <tr>
          <td style={{color}}>-</td>
          <td>-</td>
          <td><span>-</span></td>
          <td><span>-</span></td>
        </tr>
      )
    }
  }
  renderTable(orders){
    var items = orders.map(({receivesToChain,sendsFromChain,amount,price,id,collateralizedNrg,blockHeight,depositLeft,settleLeft},i) => {

      return (
        <tr style={{cursor:'pointer'}}>
          {/* <td>{Math.round(price*lowestDenom)/lowestDenom}</td> */}
          <td>{amount}</td>
          <td>{collateralizedNrg}</td>
          <td>{settleLeft}</td>
        </tr>
      );
    });

    let amountText = this.props.type === 'buy' ? orders[0].receivesToChain.toUpperCase() : orders[0].sendsFromChain.toUpperCase();
    let priceText = this.props.type === 'buy' ? orders[0].sendsFromChain.toUpperCase() : orders[0].receivesToChain.toUpperCase();

    return (
      <div className="" style={{maxHeight:'300px',overflowY:'scroll',width:'250px'}}>
        <table className="white-text transferDetails2" style={{tableLayout:"fixed"}}>
          <thead>
            <tr>
              {/* <th>Price ({priceText})</th> */}
              <th>Amount ({amountText})</th>
              <th>Collateral (NRG)</th>
              <th>Settlement</th>
            </tr>
          </thead>
          <tbody style={{lineHeight:'20px',padding:'0px'}}>
            {items}
          </tbody>
        </table>
      </div>
		)
  }

  handleFormSubmit({id,type,price,amount}) {

    $('#amount')[0].value = parseFloat(amount);
    $('#price')[0].value = parseFloat(price);

    this.props.setPrice(parseFloat(price),()=>{});
    this.props.setAmount(parseFloat(amount),()=>{});

    if(type !== 'buy') {
      $('#acquire')[0].click();
      this.props.setOrderType("BUY");
    }
    else {
      $('#leaseout')[0].click();
      this.props.setOrderType("SELL");
    }
    $('#amount').focus()
    this.props.matchOrders();
  }
}

export default connect(()=>({}), {setPrice,setAmount,setOrderType,matchOrders})(OrderItem);
